// Centralized SEO configuration for Flycher.
// SITE_URL can be overridden by REACT_APP_SITE_URL at build time.
// Defaults to the public Flycher brand domain.
export const SITE_URL = (
  process.env.REACT_APP_SITE_URL || "https://flycher.com"
).replace(/\/$/, "");

export const SITE_NAME = "Flycher";
export const SITE_TAGLINE =
  "Free AI Travel Planner for India — itinerary, visa, budget, forex";
export const SITE_DESCRIPTION =
  "The free AI travel planner & AI trip planner for India. Generate AI itineraries day-by-day, check visa & budget in INR, compare forex cards, and plan trips to Vietnam, Thailand, Bali, Japan, Maldives, Singapore and more — all free.";

// Default Open Graph image. Replace with a branded asset once available.
export const DEFAULT_OG_IMAGE =
  "https://images.unsplash.com/photo-1542038784456-1ea8e935640e?auto=format&fit=crop&w=1200&q=80";

export const absoluteUrl = (path = "/") => {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_URL}${p}`;
};
